import { zodStringNullable } from '@qapline/helpers';
import { z } from 'zod';

import { ECountry } from '../../country/types';
import { rampSchema } from './ramp';

export const locationSchema = z.object({
    location_id: z.number(),
    locationVersion_id: z.number(),
    city: zodStringNullable(),
    name: zodStringNullable(),
    country: zodStringNullable(),
    countryCode: z.nativeEnum(ECountry).nullable(),
    postalCode: zodStringNullable(),
    street: zodStringNullable(),
    latitude: z.number({ coerce: true }).nullable(),
    longitude: z.number({ coerce: true }).nullable(),
    email: zodStringNullable(),
    firstName: zodStringNullable(),
    lastName: zodStringNullable(),
    note: zodStringNullable(),
    phone: zodStringNullable(),
    discharge: z.boolean(),
    loading: z.boolean(),
    areaMap: zodStringNullable(),
    customer_id: z.number(),
    ramps: z.array(rampSchema).optional(),
});

export type TLocation = z.infer<typeof locationSchema>;
